/**
 * Patch ResizeObserver so callbacks run in requestAnimationFrame and never receive
 * entries for detached elements (avoids getComputedStyle on unmounted nodes).
 * Prevents "ResizeObserver loop completed with undelivered notifications"
 * and "parameter 1 is not of type 'Element'" when switching tabs / unmounting Chat (Virtuoso).
 * Must be imported first in index.js.
 */
const NativeResizeObserver = window.ResizeObserver
if (NativeResizeObserver) {
  window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
    constructor (callback) {
      const deferredCallback = (entries, observer) => {
        window.requestAnimationFrame(() => {
          const connectedEntries = entries.filter(
            entry => entry.target && typeof entry.target.isConnected === 'boolean' && entry.target.isConnected
          )
          if (connectedEntries.length > 0) {
            callback(connectedEntries, observer)
          }
        })
      }
      super(deferredCallback)
    }
  }
}
